"use client";
import * as React from "react";
const SvgMailOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 2.13c0-.9-.72-1.63-1.6-1.63H1.6C.72.5 0 1.23 0 2.13v9.75c0 .89.72 1.62 1.6 1.62h12.8c.88 0 1.6-.73 1.6-1.62zm-1.6 0L8 6.18 1.6 2.13zm0 9.75H1.6V3.74L8 7.81l6.4-4.06z" }));
export {
  SvgMailOutlined as default
};
